import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
    maxWidth: theme.marginBase * 35,
  },
}));

interface TableColumnHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const TableColumnHeader = ({
  children,
  className,
}: TableColumnHeaderProps) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.headerContainer, className)}>
      {children}
    </div>
  );
};
